import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Segment } from '../services/analytics-services/segment';
import Global from '../store/global-selectors';

/**
 * A hook that returns a function for sending metrics with the seller ID already included.
 * @returns {(eventName: string, additionalParams?: Record<string, unknown>) => void} A function that takes an event name and optional additional parameters
 */
export const useSendMetrics = () => {
  const sellerId = useSelector(Global.selectSellerSellerId);

  return useCallback(
    (eventName: string, additionalParams: Record<string, unknown> = {}) => {
      const params = {
        sellerId,
        ...additionalParams,
      };

      Segment.trackEvent(eventName, params);
    },
    [sellerId],
  );
};
